import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { theme } from 'antd';

import { DeviceConnectivity, RefrigeratedAirDryerActivityState } from '@/constants/enums';
import ConditionalToolTip from '@/utils/ConditionalTooltip';
import SnowflakeIcon from '@/comp/common/icons/SnowflakeIcon';
import ConnectivityDisconnectedIcon from '@/comp/common/icons/ConnectivityDisconnectedIcon';

interface getConnectivityParams {
  connectivity: DeviceConnectivity;
  activity: RefrigeratedAirDryerActivityState;
}

const { useToken } = theme;

export function GetConnectivityIconAndStatus(params: getConnectivityParams): { icon: JSX.Element; status: string } {
  const { t } = useTranslation();
  const { token } = useToken();
  const { connectivity, activity } = params;

  let status = '';
  let shape: JSX.Element = null;
  let shouldShowTooltip = true;

  switch (connectivity?.toLowerCase()) {
    case DeviceConnectivity.Connected:
      if (!activity || typeof activity !== 'string') {
        shape = null;
        shouldShowTooltip = false;
      }
      switch (activity?.toLowerCase()) {
        case RefrigeratedAirDryerActivityState.ON:
          status = t(RefrigeratedAirDryerActivityState.ON);
          shape = <SnowflakeIcon />;
          break;

        case RefrigeratedAirDryerActivityState.OFF:
          status = t(RefrigeratedAirDryerActivityState.OFF);
          shape = (
            <SnowflakeIcon iconFillColor={token.colorBgContainerDisabled} iconStrokeColor={token.colorBgTextActive} />
          );
          break;

        default:
          shape = null;
          shouldShowTooltip = false;
      }
      break;

    case DeviceConnectivity.Disconnected:
      status = t(DeviceConnectivity.Disconnected);
      shape = <ConnectivityDisconnectedIcon width={18} height={18} />;
      break;

    default:
      shape = null;
      shouldShowTooltip = false;
      break;
  }

  return {
    icon: (
      <ConditionalToolTip condition={shouldShowTooltip} content={status}>
        <ConnectivityIconWrapper>{shape}</ConnectivityIconWrapper>
      </ConditionalToolTip>
    ),
    status: status,
  };
}

const ConnectivityIconWrapper = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  z-index: 3;
`;
